// src/admin/components/HomePageConfig/ColorPicker.jsx
import React from "react";

export default function ColorPicker({ label, value, onChange, description = "", allowTransparent = true }) {
  // Check if current value is transparent
  const isTransparent = value === "transparent" || value === "rgba(0,0,0,0)" || value === "" || !value;
  
  // Handle transparent selection
  const handleTransparentToggle = () => {
    if (isTransparent) {
      onChange("#000000"); // Default to black when switching from transparent
    } else {
      onChange("transparent");
    }
  };
  
  // Handle color change
  const handleColorChange = (colorValue) => {
    onChange(colorValue);
  };
  
  return (
    <div className="color-picker-group">
      <label>{label}</label>
      
      {allowTransparent && (
        <div style={{ marginBottom: "8px" }}>
          <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={isTransparent}
              onChange={handleTransparentToggle}
              style={{ width: "16px", height: "16px", cursor: "pointer" }}
            />
            <span style={{ fontSize: "14px" }}>Transparent / No Color</span>
          </label>
        </div>
      )}
      
      <div 
        style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: "10px",
          opacity: isTransparent ? 0.5 : 1,
          pointerEvents: isTransparent ? "none" : "auto"
        }}
      >
        <div style={{ position: "relative" }}>
          <input
            type="color"
            value={isTransparent ? "#000000" : value}
            onChange={(e) => handleColorChange(e.target.value)}
            style={{ 
              width: "40px", 
              height: "40px", 
              cursor: "pointer",
              border: "1px solid #ddd",
              borderRadius: "4px"
            }}
            disabled={isTransparent}
          />
          {isTransparent && (
            <div 
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "30px",
                height: "2px",
                backgroundColor: "#ff0000",
                rotate: "45deg"
              }}
            />
          )}
        </div>
        
        <input
          type="text"
          value={isTransparent ? "transparent" : value}
          onChange={(e) => {
            if (e.target.value.toLowerCase() === "transparent") {
              handleColorChange("transparent");
            } else {
              handleColorChange(e.target.value);
            }
          }}
          style={{ 
            flex: 1, 
            padding: "8px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            backgroundColor: isTransparent ? "#f5f5f5" : "white"
          }}
          placeholder="#000000 or transparent"
          disabled={isTransparent}
        />
      </div>
      
      {description && (
        <small style={{ color: "#666", fontSize: "12px", marginTop: "4px", display: "block" }}>
          {description}
        </small>
      )}
      
      {isTransparent && (
        <small style={{ 
          color: "#666", 
          fontSize: "12px", 
          marginTop: "4px", 
          display: "block",
          fontStyle: "italic" 
        }}>
          Current: Transparent (no background/color)
        </small>
      )}
    </div>
  );
}
